import template from './advertnav.html';
import controller from './advertnav.controller';
import './advertnav.scss';

let advertnavComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default advertnavComponent;
